import React from 'react';

const ShippingMethodsForm = ({
    shippingMethodsData,
    errors,
    selectedShipping,
    handleShippingMethodSelect,
    handleShippingSubmit,
    shippingLoading,
    loading
}) => {
    return (
        <div className="form-section">
            <h2 className="form-title">Shipping Methods</h2>

            {errors.shipping && (
                <div className="error-message">
                    {errors.shipping}
                </div>
            )}

            {loading ? (
                <div className="loading-container">
                    <div className="loading-spinner" />
                </div>
            ) : shippingMethodsData?.cart?.shipping_addresses?.[0]?.available_shipping_methods?.length > 0 ? (
                <div className="shipping-methods-list">
                    {shippingMethodsData.cart.shipping_addresses[0].available_shipping_methods.map((method) => {
                        const methodCode = method.method_code || method.carrier_code || 'default';
                        const shippingKey = `${method.carrier_code}_${methodCode}`;
                        const isSelected = selectedShipping === shippingKey;

                        return (
                            <div
                                key={shippingKey}
                                className={`shipping-method-item ${isSelected ? 'selected' : ''}`}
                                onClick={() => handleShippingMethodSelect(method.carrier_code, methodCode)}
                            >
                                <div className="shipping-method-content">
                                    <div className="shipping-method-info">
                                        <div className={`radio-button ${isSelected ? 'selected' : ''}`} />
                                        <div>
                                            <h3 className="shipping-method-title">{method.carrier_title}</h3>
                                            <p className="shipping-method-description">{method.method_title}</p>
                                        </div>
                                    </div>
                                    <div className="shipping-method-price">
                                        ${method.amount.value.toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p>No shipping methods available. Please check your address.</p>
            )}

            <button
                onClick={handleShippingSubmit}
                disabled={shippingLoading}
                className="btn-primary"
            >
                {shippingLoading && (
                    <div className="loading-spinner" />
                )}
                {shippingLoading ? 'Processing...' : 'Continue to Payment'}
            </button>
        </div>
    );
};

export default ShippingMethodsForm;